import { general, generalFields } from 'shared/model/schemas/rules';

export const activateCardSchema = (t: (descriptor: object, values?: any) => string) => ({
    cvv: [
        ...generalFields(t)['cvv'],
        general(t)['required-field'],
    ],
});